// extracted by mini-css-extract-plugin
export default {"ApplicationLogin":"style_ApplicationLogin__Fcj-P"};